import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import isTouchDevice from "@insite/client-framework/Common/Utilities/isTouchDevice";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { HasCategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedBrandPath, getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    getProductListDataView,
    getProductListDataViewProperty,
} from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { ProductCarouselProductStyles } from "@insite/content-library/Components/ProductCarouselProduct";
import { FlexWrapContainerProps } from "@insite/content-library/Widgets/Brand/FlexWrapContainer";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import cenSetSelectedArticleType from "@tCentro/Handlers/CenSelectedArticleTypeHandler";
import ArrowRightLongIcon from "@tCentro/Icons/ArrowRightLongIcon";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import useEmblaCarousel from "embla-carousel-react";
import sortBy from "lodash/sortBy";
import qs from "qs";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

interface DivisionModal {
    fields: {
        slideTitle: string;
    };
}
interface articalList {
    description: string;
    dateTab: any;
    authorTab: any;
    articalTab: any;
    slideTitle: string;
    imageTab: any;
}

const enum fields {
    slideTitle = "slideTitle",
    slides = "slides",
    maxNumberOfColumns = "maxNumberOfColumns",
    defaultPageSize = "defaultPageSize",
    paginationBackgroundColor = "paginationBackgroundColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.slides]: DivisionModal[];
        [fields.slideTitle]: string;
        [fields.maxNumberOfColumns]: number;
        [fields.defaultPageSize]: number;
        [fields.paginationBackgroundColor]: string;
    };
    categoryId: string;
}

const mapStateToProps = (state: ApplicationState & CustomApplicationState, props: OwnProps) => {
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPageState = getCatalogPageStateByPath(state, categoryPath);
    const { pathname } = getLocation(state);
    const brandPath = getSelectedBrandPath(state) || pathname;
    const { productFilters } = state.pages.productList;
    const pages = getDataView(state.data.pages, { parentNodeId: getCurrentPage(state).nodeId });
    let filteredPages = pages.value;
    let links: SafeDictionary<PageLinkModel> = {};
    if (pages.value) {
        links = pages.value.reduce(
            (links, page) => ({ ...links, [page.nodeId]: getPageLinkByNodeId(state, page.nodeId) }),
            {},
        );
    }
    let newsListFilters: any = {};
    if (filteredPages) {
        if (location.search) {
            const parsedQuery = parseQueryString<any>(location.search);
            newsListFilters = {
                AutomationRobotics: parsedQuery.AutomationRobotics ? true : undefined,
                InstrumentationMeasurementControl: parsedQuery.InstrumentationMeasurementControl ? true : undefined,
                BulkMaterialHandlingDustCollection: parsedQuery.BulkMaterialHandlingDustCollection ? true : undefined,
                FiltrationProcessSystems: parsedQuery.FiltrationProcessSystems ? true : undefined,
                PumpSeal: parsedQuery.PumpSeal ? true : undefined,
                ValveActuationEngineeredProducts: parsedQuery.ValveActuationEngineeredProducts ? true : undefined,
                General: parsedQuery.General ? true : undefined,
                contentType: parsedQuery.contentType,
                sort: parsedQuery.sort,
            };

            switch (newsListFilters.sort) {
                case "1":
                    filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]).reverse();
                    break;
                case "2":
                    filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]);
                    break;
                case "3":
                    filteredPages = sortBy(filteredPages, o => o.fields["author"]);
                    break;
                case "4":
                    filteredPages = sortBy(filteredPages, o => o.fields["author"]).reverse();
                    break;
                case "5":
                    filteredPages = sortBy(filteredPages, o => o.fields["title"]);
                    break;
                case "6":
                    filteredPages = sortBy(filteredPages, o => o.fields["title"]).reverse();
                    break;
                default:
                    filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]).reverse();
                    break;
            }
        }
        if (!newsListFilters.sort) {
            filteredPages = sortBy(filteredPages, o => o.fields["publishDate"]).reverse();
        }
    }

    return {
        query: location.search,
        catalogPageState,
        category: getCategoryState(state, props.categoryId).value,
        brandPath,
        productsDataView: getProductListDataView(state),
        categoryFacets: getProductListDataViewProperty(state, "properties"),
        productFiltersQuery: productFilters.query,
        breadCrumbs: state.components.breadcrumbs.links,
        filteredPages,
        cenSelectedArticleType: state.t_components.selectedArticleType.selectedArticleType,
        links,
        cenContentTab: state.t_components.selectedContentType.selectedContentType,
        newsListFilters,
        searchQuery: state.t_components.searchQuery.searchQuery,
        location,
        pages,
        parameter: state.pages.newsList.getNewsPagesParameters[getCurrentPage(state).nodeId] ?? {
            parentNodeId: getCurrentPage(state).nodeId,
        },
        isLoading: state.t_components?.storeBlogResult?.isLoading,
    };
};
const mapDispatchToProps = { cenSetSelectedArticleType };

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    ThemeProps<BaseTheme> &
    HasShellContext &
    HasCategoryContext &
    HasHistory;

export interface CENBlogCategorySectionStyles {
    infoCardTitle?: TypographyProps;
    container?: InjectableCss;
    wrapper?: InjectableCss;
    imageContainer?: FlexWrapContainerProps;
    link?: LinkProps;
    image?: LazyImageProps;
    mainContainer?: GridContainerProps;
    prevArrowGridItem?: GridItemProps;
    prevArrowButton?: ButtonPresentationProps;
    nextArrowGridItem?: GridItemProps;
    nextArrowButton?: ButtonPresentationProps;
    carouselGridItem?: GridItemProps;
    carouselWrapper?: InjectableCss;
    carouselContainer?: InjectableCss;
    buttonLink?: LinkPresentationProps;
    carouselSlidesContainer?: InjectableCss;
    carouselSlide?: InjectableCss;
    carouselSlideInner?: InjectableCss;
    carouselProductStyles?: ProductCarouselProductStyles;
    subcategoryNameStyles?: InjectableCss;
    subcategoryDescriptionStyles?: InjectableCss;
    subCategoryContentContainer: InjectableCss;
    categoryNameTitleStyle?: InjectableCss;
    imglinkStyles?: InjectableCss;
    imgStyles?: InjectableCss;
    publishDate?: InjectableCss;
    articlesContentTypeStyles?: InjectableCss;
    sectionTitle?: InjectableCss;
    readAllLink?: InjectableCss;
    articleNameStyles?: InjectableCss;
    aricleCardContentContainer?: InjectableCss;
    mostRecentGridContainer?: InjectableCss;
    readAllArrowStyles?: InjectableCss;
    rightArrowIconStyles?: IconPresentationProps;
    pagination?: PaginationPresentationProps;
    noDataStyles?: InjectableCss;
    mostRecentParentContainer?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    carouselGridItemCustom: GridItemProps;
    authorText: InjectableCss;
}

export const listStyles: CENBlogCategorySectionStyles = {
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    mostRecentParentContainer: {
        css: css`
            margin-top: 64px;
            padding: 0px 19px !important;
        `,
    },
    noDataStyles: {
        css: css`
            margin-top: 64px;
            margin-bottom: 20px;
            text-align: center;
            font-family: Poppins;
            font-weight: 700;
            font-size: 32px;
            line-height: 40px;
            letter-spacing: 0%;
            text-align: center;
            color: ${getProp("theme.typography.p.color")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-family: Poppins;
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 32px;
                        letter-spacing: 0%;
                        text-align: center;
                    `,
                    css`
                        font-family: Poppins;
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 32px;
                        letter-spacing: 0%;
                        text-align: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    pagination: {
        cssOverrides: {
            pagination: css`
                padding-top: 15px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css``,
                        css``,
                        css`
                            justify-content: space-between;
                        `,
                        null,
                        null,
                    ])}
                > nav[aria-label^="Pagination navigation"] {
                    justify-content: center;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css``,
                            css``,
                            css`
                                justify-content: flex-start;
                                padding-left: 20px;
                            `,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    rightArrowIconStyles: {
        size: 11,
        css: css`
            span {
                height: 11.25px !important;
                width: 18px !important;
                > svg {
                    height: 11.25px !important;
                    width: 18px !important;
                }
            }
        `,
    },
    readAllArrowStyles: {
        css: css`
            display: flex;
            gap: 2px;
            margin-top: 4px;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                        text-align: center;
                    `,
                    css`
                        justify-content: center;
                        text-align: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    aricleCardContentContainer: {
        css: css`
            padding: 24px;
            background-color: #f2f2f2;
            display: flex;
            flex-direction: column;
            justify-content: stretch;
            flex: 1;
            gap: 8px;
            align-items: flex-start;
        `,
    },
    articleNameStyles: {
        css: css`
            span {
                font-family: Poppins;
                font-weight: 600;
                font-size: 18px;
                line-height: 24px;
                color: ${getProp("theme.typography.p.color")} !important;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
        `,
    },
    readAllLink: {
        css: css`
            font-family: Poppins;
            font-weight: 600;
            font-size: 18px;
            line-height: 24px;
            color: ${getColor("text.link")} !important;
            cursor: pointer;
        `,
    },
    sectionTitle: {
        css: css`
            font-family: Poppins;
            font-weight: 700;
            font-size: 32px;
            line-height: 40px;
            color: ${getProp("theme.typography.p.color")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-family: Poppins;
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 32px;
                        text-align: center;
                    `,
                    css`
                        font-family: Poppins;
                        font-weight: 600;
                        font-size: 24px;
                        line-height: 32px;
                        text-align: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    articlesContentTypeStyles: {
        css: css`
            font-family: Poppins;
            font-weight: 400;
            font-style: italic;
            font-size: 12px;
            line-height: 16px;
        `,
    },
    publishDate: {
        css: css`
            color: ${getColor("text.link")};
            font-family: Poppins;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            > span {
                padding: 5px;
                color: #9e9d9e;
            }
        `,
    },
    authorText: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.bold};
            margin-left: 4px;
            color: ${getColor("text.link")} !important;
            font-family: Poppins;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0%;
        `,
    },

    imgStyles: {
        css: css`
            img {
                height: 100%;
                object-fit: contain;
                aspect-ratio: 25 / 14;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            aspect-ratio: 25 / 14;
                        `,
                        css`
                            aspect-ratio: 25 / 14;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }
        `,
    },
    imglinkStyles: {
        css: css`
            width: 100%;
            height: 100%;
        `,
    },
    categoryNameTitleStyle: {
        css: css`
            font-family: Poppins;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            color: ${getProp("theme.typography.p.color")};
            margin-bottom: 16px;
        `,
    },
    subCategoryContentContainer: {
        css: css`
            padding: 24px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: -4px;
        `,
    },
    subcategoryNameStyles: {
        css: css`
            max-width: 137px;
            span {
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                text-align: left;
                color: ${getProp("theme.typography.p.color")} !important;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
        `,
    },
    subcategoryDescriptionStyles: {
        css: css`
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            p {
                font-family: Poppins;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
                // margin-top: 16px;
                color: ${getProp("theme.typography.p.color")} !important;
            }
        `,
    },
    image: {
        css: css`
            justify-content: flex-start;
            height: 100%;
            img {
                object-fit: cover;
                width: 100%;
                border-bottom: 1px solid #e0dfe0;
                height: 100%;
            }
        `,
    },
    infoCardTitle: {
        variant: "h2",
        css: css`
            text-align: center;
            font-size: 1.5rem;
            line-height: 33px;
            margin-bottom: 0rem;
            padding-top: 20px;
        `,
    },
    container: {
        css: css`
            margin: 20px 0 20px 0;
            text-align: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 1rem;
                        `,
                        null,
                        null,
                        css`
                            padding: 0 5rem;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    wrapper: {
        css: css`
            /* background-color: #ebebeb; */
            margin-bottom: 64px;
            padding: 0px 19px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100% !important;
                        /* padding: 20px; */
                        flex-wrap: wrap;
                        margin-top: 32px;
                    `,
                    css`
                        max-width: 100% !important;
                        /* padding: 20px; */
                        flex-wrap: wrap;
                    `,
                    css`
                        /* max-width: 720px !important; */
                        flex-wrap: wrap;
                        margin-top: 40px;
                    `,
                    css`
                        /* max-width: 917px !important; */
                        padding: 0px;
                        flex-wrap: nowrap;
                    `,
                    css`
                        /* max-width: 1300px !important; */
                        flex-wrap: nowrap;
                        padding: 0px;
                    `,
                ])}
        `,
    },
    mainContainer: {
        gap: 0,
        css: css`
            position: relative;
            margin-top: 32px;
        `,
    },
    prevArrowGridItem: {
        width: 1,
        align: "middle",
        css: css`
            position: absolute;
            z-index: 999;
            top: 50%;
            transform: translateY(-50%);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            background: ${getColor("primary")};
            border-radius: 50%;
            position: relative;
            min-height: auto !important;
            width: 34px;
            height: 34px;
            span {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            svg {
                width: 30px;
                height: 30px;
                stroke: white;
                position: absolute;
                top: 1px;
                left: 0px;
            }
            &:focus {
                outline: none;
            }
        `,
    },
    nextArrowGridItem: {
        width: 1,
        align: "middle",

        css: css`
            position: absolute;
            z-index: 999;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: none;
                    `,
                    css`
                        display: none;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    nextArrowButton: {
        // variant: "secondary",
        color: "text.main",
        css: css`
            border: 0;
            padding: 0;
            background: ${getColor("primary")};
            border-radius: 50%;
            position: relative;
            min-height: auto !important;
            width: 34px;
            height: 34px;
            span {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
            svg {
                width: 30px;
                height: 30px;
                stroke: white;
                position: absolute;
                top: 1px;
                left: 3px;
            }
            &:focus {
                outline: none;
            }
            &:hover {
                background: ${getColor("primary")};
            }
        `,
    },
    carouselGridItemCustom: {
        width: [12, 12, 10, 10, 10],
        css: css`
            &:after {
                content: "";
                position: absolute;
                z-index: 1;
                width: 100px;
                box-sizing: border-box;
                right: 0px;
                height: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
        `,
    },
    carouselGridItem: {
        width: [12, 12, 10, 10, 10],
        css: css`
            &:after {
                content: "";
                position: absolute;
                z-index: 1;
                width: 100px;
                box-sizing: border-box;
                right: 0px;
                height: 100%;
                background: linear-gradient(269deg, rgb(255 255 255) 30%, rgb(255 255 255 / 0%) 100%);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            display: none;
                        `,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                    `,
                ])}
        `,
    },
    carouselWrapper: {
        css: css`
            width: 100%;
            position: relative;
        `,
    },
    carouselContainer: {
        css: css`
            overflow: hidden;
            /* padding: 30px 7px 13px; */
        `,
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            /* padding-top: 10px; */
            gap: 24px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    carouselSlide: {
        css: css`
            padding: 0;
            position: relative;
            flex: 0 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                    `,
                    css`
                        max-width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    carouselSlideInner: {
        css: css`
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            /* cursor: pointer; */
            position: relative;
            justify-content: flex-start;
            background-color: white;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                    `,

                    css`
                        max-width: 100%;
                    `,

                    null,

                    null,

                    null,
                ])}
        `,
    },
    imageContainer: {
        css: css`
            height: auto;
            width: 100%;
            background-color: #f8f8f8;
            span {
                height: 100%;
                width: 100%;
            }
            div[class^="LazyImageStyle"] {
                width: 100%;
            }
            span[class^="IconWrapper"] {
                width: 100%;
                justify-content: center;
            }
        `,
    },
};

const styles = listStyles;

const CENBlogArticleCarousel: FC<Props> = ({
    fields,
    shellContext,
    theme,
    filteredPages,
    cenSelectedArticleType,
    links,
    cenContentTab,
    newsListFilters,
    history,
    cenSetSelectedArticleType,
    location,
    parameter,
    pages,
    searchQuery,
    isLoading,
}) => {
    const [totalItems, setTotalItems] = useState();
    const [sortedAndPagedPages, setSortedAndPagedPages] = useState<any[]>([]);
    const [pageArticles, setPageArticles] = useState("");
    const [page, setPage] = useState(parameter.page ?? 1);
    const [pageSize, setPageSize] = useState(parameter.pageSize ?? fields.defaultPageSize);
    const queryParams = new URLSearchParams(location.search);
    const searchQueryCarousel = queryParams.get("search");
    const [pageQuery, setPageQuery] = useState<any>(queryParams.get("page") ?? 1);
    const groupedArticles = filteredPages?.reduce<Record<string, any[]>>((acc, article) => {
        const articleType = article.fields?.articlesType;
        if (!articleType) {
            return acc;
        }

        if (!acc[articleType]) {
            acc[articleType] = [];
        }

        acc[articleType].push(article);
        return acc;
    }, {});

    const filteredArticles = cenSelectedArticleType
        ? { [cenSelectedArticleType]: groupedArticles?.[cenSelectedArticleType] || [] }
        : groupedArticles;
    const contentTypeMapping = {
        "1": "isArticlesContentType",
        "2": "isCaseStudiesContentType",
        "3": "isVideosContentType",
        "4": "isWhitePapersContentType",
        "5": "isDocumentsDataSheetsContentType",
        "6": "isTutorialsContentType",
        "7": "isAnnouncementsContentType",
    };
    const getFilteredArticles = (
        articles: Record<string, any[]>,
        selectedContentTypeOptions: any,
        selectedArticleType: string,
    ) => {
        if (!articles) {
            return {};
        }

        // Step 1: Filter articles based on `selectedArticleType`
        let filteredArticles =
            selectedArticleType === "allArticlesType"
                ? articles
                : Object.entries(articles).reduce<Record<string, any[]>>((acc, [articleType, articleList]) => {
                      if (articleType === selectedArticleType) {
                          acc[articleType] = articleList;
                      }
                      return acc;
                  }, {});

        // Step 2: If "All" checkbox ("0") is selected, return everything
        if (selectedContentTypeOptions.includes("0")) {
            return filteredArticles;
        }

        // Step 3: Filter based on `selectedContentTypeOptions`
        if (selectedContentTypeOptions.length > 0) {
            filteredArticles = Object.entries(filteredArticles).reduce<Record<string, any[]>>(
                (acc, [articleType, articleList]) => {
                    const filteredList = articleList.filter(article =>
                        selectedContentTypeOptions.some((contentTypeId: string) => {
                            const mappedField = contentTypeMapping[contentTypeId as keyof typeof contentTypeMapping];
                            return mappedField && article.fields?.[mappedField];
                        }),
                    );

                    if (filteredList.length > 0) {
                        acc[articleType] = filteredList;
                    }

                    return acc;
                },
                {},
            );
        }

        return filteredArticles;
    };

    // Apply filtering before rendering
    const filteredGroupedArticles = groupedArticles
        ? getFilteredArticles(groupedArticles, cenContentTab, cenSelectedArticleType)
        : "";
    const updateQueryString = (page: number, pageSize?: number, newsFilters?: any) => {
        const filters = newsFilters || newsListFilters || undefined;

        let newLocation = `${location.pathname}?page=${page}`;
        if (pageSize) {
            newLocation += `&pageSize=${pageSize}`;
        }
        if (filters) {
            const filterQuery = qs.stringify(filters, { arrayFormat: "comma", skipNulls: true });
            if (filterQuery) {
                newLocation += `&${filterQuery}`;
            }
        }
        history.push(newLocation);
    };
    const filteredFilteredArticles = filteredArticles
        ? getFilteredArticles(filteredArticles, cenContentTab, cenSelectedArticleType)
        : "";

    const handleOnClickArticle = (selectedValue?: string) => {
        const newsListFilterss = { ...newsListFilters };
        const articleCategories = [
            "AutomationRobotics",
            "InstrumentationMeasurementControl",
            "BulkMaterialHandlingDustCollection",
            "FiltrationProcessSystems",
            "PumpSeal",
            "ValveActuationEngineeredProducts",
            "General",
        ];
        if (selectedValue) {
            const cleanedStr = selectedValue.replace(/[^\w]/g, "");

            articleCategories.forEach(category => {
                if (category !== cleanedStr) {
                    delete newsListFilterss[category];
                }
            });
            newsListFilterss[cleanedStr] = cleanedStr !== "allArticlesType" ? "true" : undefined;
            newsListFilterss["search"] = searchQueryCarousel || undefined;
        }

        updateQueryString(1, 12, newsListFilterss);
        cenSetSelectedArticleType({ selectedArticleType: selectedValue || "allArticlesType" });
    };

    useEffect(() => {
        const queryParamsPage = new URLSearchParams(location.search);
        setPageQuery(queryParamsPage.get("page"));
    }, [location.search]);

    useEffect(() => {
        if (!filteredFilteredArticles) {
            return;
        }
        let pagedArticles: any = [];
        let total: any = 0;
        let searchArticles: any;
        Object.entries(filteredFilteredArticles).forEach(([key, articles]: any) => {
            if (Array.isArray(articles)) {
                searchArticles = (articles || []).filter(article =>
                    searchQuery?.length > 0 ? searchQuery.includes(article.name) : true,
                );
                pagedArticles = searchArticles.slice((pageQuery - 1) * pageSize, pageQuery * pageSize);
                total += searchArticles.length;
            }
        });

        setTotalItems(prevTotal => (prevTotal !== total ? total : prevTotal));
        setSortedAndPagedPages(prevPages =>
            JSON.stringify(prevPages) !== JSON.stringify(pagedArticles) ? pagedArticles : prevPages,
        );
        setPageArticles(prevPages =>
            JSON.stringify(prevPages) !== JSON.stringify(searchArticles) ? searchArticles : prevPages,
        );
    }, [filteredFilteredArticles, pageQuery, pageSize]);
    const changePage = (newPageIndex: number) => {
        setPage(newPageIndex);
        updateQueryString(newPageIndex, pageSize);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize); // Update pageSize state
        setPage(1);
        updateQueryString(1, newPageSize);
    };

    const groupArticles = () => {
        const search = searchQuery || "";
        const carouselSearch = searchQueryCarousel || "";
        return Object.entries(filteredGroupedArticles).map(([articleType, articles]) => ({
            articleType,
            articles:
                search.length === 0 && carouselSearch.length !== 0
                    ? []
                    : search.length === 0 && carouselSearch.length === 0
                      ? articles
                      : articles.filter((article: any) => search.includes(article.name)),
        }));
    };

    const groupedAllArticles = groupArticles();
    const getArticleTypeLabel = (articleType: string) => {
        switch (articleType) {
            case "AutomationRobotics":
                return "Automation & Robotics";
            case "InstrumentationMeasurementControl":
                return "Instrumentation, Measurement & Control";
            case "BulkMaterialHandlingDustCollection":
                return "Bulk Material Handling & Dust Collection";
            case "FiltrationProcessSystems":
                return "Filtration & Process Systems";
            case "PumpSeal":
                return "Pump & Seal";
            case "ValveActuationEngineeredProducts":
                return "Valve, Actuation & Engineered Products";
            case "General":
                return "General";
            default:
                return "";
        }
    };
    const ArticleEmblaCarousel = ({ articleType, articles }: { articleType: string; articles: [] }) => {
        const [emblaRef, embla] = useEmblaCarousel();
        const [windowResizeTime, setWindowResizeTime] = React.useState(0);
        const [canScrollPrev, setCanScrollPrev] = React.useState(false);
        const [canScrollNext, setCanScrollNext] = React.useState(false);

        const setCanScroll = () => {
            if (shellContext.isInShell) {
                return;
            }
            setCanScrollPrev(!!embla && embla.canScrollPrev());
            setCanScrollNext(!!embla && embla.canScrollNext());
        };

        const getSlidesToScroll = React.useCallback(() => {
            const maxNumberOfColumns = fields.maxNumberOfColumns || 6;
            if (typeof window === "undefined") {
                return maxNumberOfColumns;
            }

            let localSlidesToScroll: number;

            if (window.innerWidth < theme.breakpoints.values[1]) {
                localSlidesToScroll = 1;
            } else if (window.innerWidth < theme.breakpoints.values[2]) {
                localSlidesToScroll = 1;
            } else if (window.innerWidth < theme.breakpoints.values[3]) {
                localSlidesToScroll = 3;
            } else if (window.innerWidth < theme.breakpoints.values[4]) {
                localSlidesToScroll = 4;
            } else if (window.innerWidth < theme.breakpoints.values[5]) {
                localSlidesToScroll = 4;
            } else {
                localSlidesToScroll = 4;
            }
            return Math.min(localSlidesToScroll, maxNumberOfColumns);
        }, [fields.maxNumberOfColumns]);

        const [slidesToScroll, setSlidesToScroll] = React.useState(getSlidesToScroll());

        const getDraggable = () => {
            if (typeof window === "undefined") {
                return false;
            }

            return window.innerWidth < theme.breakpoints.values[3];
        };

        const [draggable, setDraggable] = React.useState(getDraggable());

        React.useEffect(() => {
            const newSlidesToScroll = getSlidesToScroll();
            setSlidesToScroll(newSlidesToScroll);

            const newDraggable = getDraggable();
            setDraggable(newDraggable);
        }, [fields.maxNumberOfColumns, windowResizeTime]);

        React.useEffect(() => {
            if (!embla) {
                return;
            }

            embla.on("init", setCanScroll);
            embla.on("select", setCanScroll);
            const onWindowResize = () => {
                setWindowResizeTime(Date.now());
            };

            window.addEventListener("resize", onWindowResize);
            onWindowResize();

            return () => {
                window.removeEventListener("resize", onWindowResize);
            };
        }, [embla]);

        React.useEffect(() => {
            if (!embla || articles.length === 0) {
                return;
            }

            embla.reInit({
                align: "start",
                slidesToScroll,
                watchDrag: draggable,
                dragFree: true,
            });
            setCanScroll();
        }, [embla, slidesToScroll, draggable]);

        return (
            <StyledWrapper {...styles.wrapper}>
                <Typography as="h2" {...styles.sectionTitle}>
                    {articles.length > 0 && getArticleTypeLabel(articleType)}
                </Typography>
                <StyledWrapper {...styles.readAllArrowStyles}>
                    <StyledWrapper {...styles.readAllLink} onClick={() => handleOnClickArticle(articleType)}>
                        {articles.length > 0 && `Read all ${getArticleTypeLabel(articleType)}`}
                    </StyledWrapper>
                    {articles.length > 0 && <Icon src={ArrowRightLongIcon} {...styles.rightArrowIconStyles} />}
                </StyledWrapper>

                <GridContainer {...styles.mainContainer}>
                    {/*  Carousel Navigation */}
                    {articles.length > slidesToScroll && canScrollPrev && (
                        <GridItem {...styles.prevArrowGridItem}>
                            <Button
                                {...styles.prevArrowButton}
                                onClick={() => embla?.scrollPrev()}
                                disabled={!canScrollPrev}
                            >
                                <ButtonIcon src={ChevronLeft} />
                            </Button>
                        </GridItem>
                    )}

                    {/* Carousel Items */}
                    <GridItem {...(articles.length > 4 ? styles.carouselGridItem : styles.carouselGridItemCustom)}>
                        <StyledWrapper {...styles.carouselWrapper}>
                            <StyledWrapper {...styles.carouselContainer} ref={emblaRef}>
                                <StyledWrapper {...styles.carouselSlidesContainer}>
                                    {articles.map((page: any, index: any) => (
                                        <StyledWrapper
                                            key={index}
                                            {...styles.carouselSlide}
                                            style={{
                                                width: `${
                                                    slidesToScroll === 4
                                                        ? "24%"
                                                        : slidesToScroll === 3
                                                          ? "33.33%"
                                                          : "100%"
                                                }`,
                                            }}
                                        >
                                            <StyledWrapper {...styles.carouselSlideInner}>
                                                {/* Image */}
                                                <StyledWrapper {...styles.imageContainer}>
                                                    <Link href={links[page.nodeId]?.url} {...styles.imglinkStyles}>
                                                        <LazyImage
                                                            src={
                                                                page.fields["image"]
                                                                    ? page.fields["image"]
                                                                    : page.fields["image"]
                                                            }
                                                            altText={`Article ${index}`}
                                                            {...styles.imgStyles}
                                                        />
                                                    </Link>
                                                </StyledWrapper>

                                                <StyledWrapper {...styles.aricleCardContentContainer}>
                                                    <Typography {...styles.publishDate} as="p">
                                                        <LocalizedDateTime
                                                            dateTime={new Date(page.fields.publishDate)}
                                                            options={{
                                                                year: "numeric",
                                                                month: "numeric",
                                                                day: "numeric",
                                                            }}
                                                        />{" "}
                                                        {page.fields["author"] && (
                                                            <>
                                                                <Typography as="span">|</Typography>
                                                                <Link
                                                                    href={
                                                                        page.fields["authorLink"]
                                                                            ? page.fields["authorLink"]
                                                                            : ""
                                                                    }
                                                                    {...styles.authorText}
                                                                    data-test-selector="newslist_author"
                                                                >
                                                                    {page.fields["author"]}
                                                                </Link>
                                                            </>
                                                        )}
                                                    </Typography>
                                                    <Typography as="p" {...styles.articlesContentTypeStyles}>
                                                        {[
                                                            page.fields.isArticlesContentType && "Articles",
                                                            page.fields.isCaseStudiesContentType && "Case Studies",
                                                            page.fields.isVideosContentType && "Videos",
                                                            page.fields.isWhitePapersContentType && "White Papers",
                                                            page.fields.isDocumentsDataSheetsContentType &&
                                                                "Documents & Data Sheets",
                                                            page.fields.isTutorialsContentType && "Tutorials",
                                                            page.fields.isAnnouncementsContentType && "Announcements",
                                                        ]
                                                            .filter(Boolean)
                                                            .join(", ")}
                                                    </Typography>

                                                    <StyledWrapper>
                                                        <Link
                                                            href={links[page.nodeId]?.url}
                                                            {...styles.articleNameStyles}
                                                        >
                                                            {page.name}
                                                        </Link>
                                                    </StyledWrapper>
                                                </StyledWrapper>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    ))}
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>

                    {/* Next Arrow */}
                    {articles.length > slidesToScroll && canScrollNext && (
                        <GridItem {...styles.nextArrowGridItem}>
                            <Button
                                {...styles.nextArrowButton}
                                onClick={() => embla?.scrollNext()}
                                disabled={!canScrollNext}
                            >
                                <ButtonIcon src={ChevronRight} />
                            </Button>
                        </GridItem>
                    )}
                </GridContainer>
            </StyledWrapper>
        );
    };

    const gridStyles =
        sortedAndPagedPages.length === 0
            ? `grid-template-columns: repeat(1, 100%);`
            : `grid-template-columns: repeat(4, 24%);`;

    const mostRecentGridContainer = {
        css: css`
            margin-top: 32px;
            display: grid;
            ${gridStyles};
            column-gap: 24px;
            row-gap: 24px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: repeat(1, auto);
                    `,
                    css`
                        grid-template-columns: repeat(1, auto);
                    `,
                    css`
                        ${sortedAndPagedPages.length === 0
                            ? `grid-template-columns: repeat(1, 100%);`
                            : `grid-template-columns: repeat(3, 31%);`}
                        gap: 16px;
                    `,
                    css`
                        ${gridStyles};
                    `,
                    null,
                ])}
        `,
    };
    const filteredPagesCustom =
        searchQuery?.length === 0 ? (searchQueryCarousel != null ? [] : sortedAndPagedPages) : sortedAndPagedPages;

    const showPagination =
        (typeof totalItems === "number" && totalItems > fields.defaultPageSize && !searchQueryCarousel?.length) ||
        filteredPagesCustom?.length > fields.defaultPageSize ||
        (searchQuery?.length !== 0 && pageArticles?.length > fields.defaultPageSize);
    const showNoDataFound = groupedAllArticles?.every(group => group.articles?.length === 0);
    return (
        <>
            {cenSelectedArticleType === "allArticlesType" ? (
                (pages.isLoading || isLoading) && searchQuery?.length === 0 && searchQueryCarousel != null ? (
                    <StyledWrapper {...styles.centeringWrapper}>
                        <LoadingSpinner {...styles.spinner} />
                    </StyledWrapper>
                ) : !isLoading && searchQuery?.length === 0 && searchQueryCarousel != null ? (
                    <StyledWrapper {...styles.mostRecentParentContainer}>
                        <Typography as="p" {...styles.noDataStyles}>
                            {translate("No Data Found")}
                        </Typography>
                    </StyledWrapper>
                ) : (
                    groupedAllArticles.map(
                        (group, index) =>
                            group.articles.length > 0 && (
                                <StyledWrapper key={index} style={{ marginTop: `64px` }}>
                                    <ArticleEmblaCarousel articles={group.articles} articleType={group.articleType} />
                                </StyledWrapper>
                            ),
                    )
                )
            ) : filteredFilteredArticles && Object.keys(filteredFilteredArticles).length > 0 ? (
                Object.entries(filteredFilteredArticles).map(([articleType, articles]) => (
                    <StyledWrapper key={articleType} {...styles.mostRecentParentContainer}>
                        {filteredPagesCustom?.length > 0 && (
                            <Typography as="p" {...styles.sectionTitle}>
                                {`Most Recent In ${getArticleTypeLabel(articleType)}`}
                            </Typography>
                        )}
                        <StyledWrapper {...mostRecentGridContainer}>
                            {(filteredPagesCustom || []).map((page: any, index: number) => (
                                <StyledWrapper key={index}>
                                    <StyledWrapper {...styles.carouselSlideInner}>
                                        {/* Image */}
                                        <StyledWrapper {...styles.imageContainer}>
                                            <Link href={links[page.nodeId]?.url} {...styles.imglinkStyles}>
                                                <LazyImage
                                                    src={
                                                        page.fields["image"]
                                                            ? page.fields["image"]
                                                            : page.fields["image"]
                                                    }
                                                    altText=""
                                                    {...styles.imgStyles}
                                                />
                                            </Link>
                                        </StyledWrapper>

                                        <StyledWrapper {...styles.aricleCardContentContainer}>
                                            <Typography {...styles.publishDate} as="p">
                                                <LocalizedDateTime
                                                    dateTime={new Date(page.fields["publishDate"])}
                                                    options={{
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                    }}
                                                />{" "}
                                                | {page.fields["author"]}
                                            </Typography>
                                            <Typography as="p" {...styles.articlesContentTypeStyles}>
                                                {[
                                                    page.fields["isArticlesContentType"] && "Articles",
                                                    page.fields["isCaseStudiesContentType"] && "Case Studies",
                                                    page.fields["isVideosContentType"] && "Videos",
                                                    page.fields["isWhitePapersContentType"] && "White Papers",
                                                    page.fields["isDocumentsDataSheetsContentType"] &&
                                                        "Documents & Data Sheets",
                                                    page.fields["isTutorialsContentType"] && "Tutorials",
                                                    page.fields["isAnnouncementsContentType"] && "Announcements",
                                                ]
                                                    .filter(Boolean)
                                                    .join(", ")}
                                            </Typography>

                                            <StyledWrapper>
                                                <Link href={links[page.nodeId]?.url} {...styles.articleNameStyles}>
                                                    {page.name}
                                                </Link>
                                            </StyledWrapper>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                </StyledWrapper>
                            ))}
                        </StyledWrapper>
                        {(sortedAndPagedPages?.length === 0 || filteredPagesCustom.length === 0) &&
                            ((pages.isLoading || isLoading) &&
                            searchQuery?.length === 0 &&
                            searchQueryCarousel !== null ? (
                                <StyledWrapper {...styles.centeringWrapper}>
                                    <LoadingSpinner {...styles.spinner} />
                                </StyledWrapper>
                            ) : (
                                <StyledWrapper>
                                    <Typography as="p" {...styles.noDataStyles}>
                                        {translate("No Data Found")}
                                    </Typography>
                                </StyledWrapper>
                            ))}

                        <StyledWrapper
                            css={css`
                                margin-top: 15px;
                                > div:first-child {
                                    background: ${fields.paginationBackgroundColor} !important;
                                }
                            `}
                        >
                            {showPagination && (
                                <Pagination
                                    resultsCount={totalItems ?? 0}
                                    currentPage={pageQuery}
                                    resultsPerPage={pageSize}
                                    resultsPerPageOptions={[
                                        fields.defaultPageSize,
                                        fields.defaultPageSize * 2,
                                        fields.defaultPageSize * 3,
                                        fields.defaultPageSize * 4,
                                    ]}
                                    onChangePage={changePage}
                                    onChangeResultsPerPage={changeResultsPerPage}
                                    pageSizeCookie="NewsList-PageSize"
                                    {...styles.pagination}
                                />
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                ))
            ) : (
                <StyledWrapper {...styles.mostRecentParentContainer}>
                    <Typography as="p" {...styles.noDataStyles}>
                        {translate("No Data Found")}
                    </Typography>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(
        connect(mapStateToProps, mapDispatchToProps)(withIsInShell(withTheme(CENBlogArticleCarousel))),
    ),
    definition: {
        displayName: "CEN Blog Article Carousel",
        group: "Categories",
        fieldDefinitions: [
            {
                name: fields.maxNumberOfColumns,
                displayName: "Max Number Of Columns",
                editorTemplate: "IntegerField",
                min: 1,
                max: 6,
                defaultValue: 6,
                fieldType: "General",
                sortOrder: 8,
                isVisible: () => false,
            },
            {
                name: fields.defaultPageSize,
                editorTemplate: "IntegerField",
                defaultValue: 5,
                fieldType: "General",
                min: 1,
                max: 20,
            },
            {
                name: fields.paginationBackgroundColor,
                editorTemplate: "TextField",
                defaultValue: "#linear-gradient(90deg,#266b40 27.08%,#2d804c 71.87%,#43687a 100%)",
                fieldType: "General",
                displayName: "Pagination Background Color",
            },
        ],
    },
};

export default widgetModule;
